import Footer from "components/footer/Footer";
import Header from "components/header/Header";
import SideNav from "pages/dashbaord/sideNav/SideNav";
import { authRoutes, mainRoutes, dashboardRoutes } from "./routes";
import { Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";
import NotFound from "pages/NotFound/NotFound";
import { getFromLocal, setToLocal } from "config/axiosInstance";
import { toastMessage } from "utils/toastMessageHelper";
import commonMessages from "constant/commonMessage";
import DashboardHeader from "components/header/DashboardHeader";
const { ALLOW_RESEARCHER } = commonMessages;

const Routing = () => {
  const location = useLocation();

  const WithHeader = () => {
    return (
      <>
        <Header />
        <Outlet />
        <Footer />
      </>
    );
  };

  const DashboardLayout = () => {
    return (
      <>
        <div className="dashboard">
          <DashboardHeader />
          <div className="userDashboard">
            <aside className="dashboard_nav">
              <SideNav />
            </aside>
            <div className="dashboard_pages">
              <Outlet />
            </div>
          </div>
          {/* <Footer /> */}
        </div>
      </>
    );
  };

  //Protected route
  const ProtectedRoute = ({ children }) => {
    if (!getFromLocal("token")) {
      return (
        <>
          <Navigate to="/" replace />
          {toastMessage("session Expire Login again", "error", "tokenMissing")}
        </>
      );
    } else {
      setToLocal("referrerPath", location.pathname);
      return children;
    }
  };

  const UnauthenticatedRoute = ({ children }) => {
    if (getFromLocal("token")) {
      const redirectPath =
        getFromLocal("referrerPath") || "/dashboard/create-survey";
      return <Navigate to={redirectPath} replace />;
    } else {
      return children;
    }
  };

  return (
    <>
      <Routes>
        {/* Auth Routes */}
        {authRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              <UnauthenticatedRoute>{route.element}</UnauthenticatedRoute>
            }
          />
        ))}

        {/* Main Routes with Header and Footer */}
        <Route element={<WithHeader />}>
          {mainRoutes.map((route) => (
            <Route key={route.path} path={route.path} element={route.element} />
          ))}
        </Route>

        {/* Dashboard Routes with Sidebar */}
        <Route element={<DashboardLayout />}>
          {dashboardRoutes.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={<ProtectedRoute>{route.element}</ProtectedRoute>}
            />
          ))}
        </Route>

        {/* Catch-all for unknown routes */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

export default Routing;
